import { useLocation, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { SEO } from "@/components/SEO";

const NotFound = () => {
  const location = useLocation();
  const [suggestions, setSuggestions] = useState<{name: string, path: string}[]>([]);

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );

    // Dynamic suggestions based on path
    const path = location.pathname.toLowerCase();
    const newSuggestions = [
      { name: "Home", path: "/" },
      { name: "Services", path: "/services" },
      { name: "Pricing", path: "/pricing" },
      { name: "Locations", path: "/locations" },
    ];
    
    if (path.includes("clean") || path.includes("service")) {
      newSuggestions.unshift({ name: "Deep Cleaning", path: "/services/deep-cleaning" });
    }
    if (path.includes("loc") || path.includes("city") || path.includes("area")) {
      newSuggestions.unshift({ name: "Service Areas", path: "/locations" });
    }
    if (path.includes("price") || path.includes("cost")) {
      newSuggestions.unshift({ name: "Pricing Calculator", path: "/pricing-calculator" });
    }
    if (path.includes("blog") || path.includes("article")) {
      newSuggestions.unshift({ name: "Blog", path: "/blog" });
    }
    
    // De-duplicate and limit to 4
    const uniqueSuggestions = Array.from(new Map(newSuggestions.map(item => [item.path, item])).values());
    setSuggestions(uniqueSuggestions.slice(0, 4));

    // Structured Data for 404
    let el = document.getElementById("schema-404");
    if (!el) {
      el = document.createElement('script');
      el.setAttribute('type', 'application/ld+json');
      el.setAttribute('id', 'schema-404');
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "404 Not Found",
      "description": "The requested page could not be found."
    });

    return () => {
      const elToRemove = document.getElementById("schema-404");
      if (elToRemove) elToRemove.remove();
    };
  }, [location.pathname]);

  return (
    <>
      <SEO 
        title="Page Not Found | Uplevel Cleaning" 
        description="The page you are looking for could not be found."
        url={`https://www.uplevelcleaning.com${location.pathname}`}
      />
      <div className="flex min-h-screen items-center justify-center bg-muted px-4">
        <div className="text-center max-w-md w-full">
          <h1 className="mb-4 text-6xl font-bold text-primary">404</h1>
          <p className="mb-8 text-xl text-muted-foreground">Oops! The page you're looking for doesn't exist.</p>
          
          <div className="mb-10 bg-card p-6 rounded-xl shadow-sm border border-border text-left">
            <h2 className="text-lg font-semibold mb-4 text-card-foreground">Here are some helpful links instead:</h2>
            <div className="flex flex-col gap-3">
              {suggestions.map((link, index) => (
                <Link 
                  key={index} 
                  to={link.path}
                  className="text-primary hover:text-primary/80 font-medium flex items-center transition-colors"
                >
                  <span className="mr-2">→</span> {link.name}
                </Link>
              ))}
            </div>
          </div>
          
          <Link 
            to="/" 
            className="inline-flex h-12 items-center justify-center rounded-md bg-primary px-8 text-sm font-medium text-primary-foreground shadow transition-colors hover:bg-primary/90 w-full sm:w-auto"
          >
            Return to Home
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFound;
